import { isClient } from '@vueuse/shared';

export default {
  CNY: '￥',
  UST: '$',
  // 行情页model/ws数据更新频率
  refresh_ws: 1600,
  // 当前币对 刷新频率 ms，
  refresh: 200,
  // 深度刷新频率
  refresh_depth: 1000,
  // 行情页token列表刷新频率
  refresh_tokens: 500,
  // 盘口刷新频率
  refresh_handicap: 500,
  // 最新成交刷新频率
  refresh_trade: 100,
  refresh_150: 200,
  // 深度精度值，"0"跟K线价格精度0区别
  depth: {
    100000000: -8,
    10000000: -7,
    1000000: -6,
    100000: -5,
    10000: -4,
    1000: -3,
    100: -2,
    10: -1,
    1: 0,
    0: 0,
    0.1: 1,
    0.01: 2,
    0.001: 3,
    0.0001: 4,
    0.00001: 5,
    0.000001: 6,
    '0.0000001': 7,
    '0.00000001': 8,
    '0.000000001': 9,
    '0.0000000001': 10,
    '0.00000000001': 11,
    '0.000000000001': 12,
    '0.0000000000001': 13,
    '0.00000000000001': 14,
    '0.000000000000001': 15,
    '0.0000000000000001': 16
  },
  // k线价格精度
  k: {
    0: 1,
    1: 10,
    2: 100,
    3: 1000,
    4: 10000,
    5: 100000,
    6: 1000000,
    7: 10000000,
    8: 100000000,
    9: 1000000000,
    10: 10000000000,
    11: 100000000000,
    12: 1000000000000,
    13: 10000000000000,
    14: 100000000000000,
    15: 1000000000000000,
    16: 10000000000000000
  },
  // 最新成交展示条数
  trade_limit: 50,
  rowsPerPage: 10,
  rowsPerPage1: 20,
  rowsPerPage2: 50,
  rowsPerPageOptions: [5, 10, 20],
  minLimit: 100,
  maxLimit: 200,
  totalLimit: 1000,
  // img host
  imghost: 'https://static.applecex.com',
  // 合约状态
  optionStatus: {
    SETTLE_NO: 0,
    SETTLE_DOING: 1,
    SETTLE_DONE: 2
  },
  // 永续合约杠杆小数位
  lever_decimal: 2,
  fee: 0.005,
  // 保证金率保留8位小数
  initialMargin: 8,
  // 永续合约买卖方向
  sideMap: {
    BUY: '买入',
    SELL: '卖出',
    BUY_OPEN: '买入开多',
    SELL_OPEN: '卖出开空',
    BUY_CLOSE: '买入平空',
    SELL_CLOSE: '卖出平多'
  },
  kline_type_hb: ['1', '3', '5', '15', '30', '60', '240', '1440', '10080', '44640'],
  kline_type_map_hb: {
    '1m': '1min',
    '3m': '3min',
    '5m': '5min',
    '15m': '15min',
    '30m': '30min',
    '1h': '60min',
    '4h': '4hour',
    '1d': '1day',
    '1w': '1week',
    '1M': '1mon'
  },
  klineBtns: [
    // type 1 时 2分 3其他
    {
      slug: 'Time', // 窄屏展示
      resolution: '1', // 传给K线的参数
      chartType: 3, // 图表类型
      res: 'Time', // 区分分时与1m
      full: 'Time', // 宽屏展示
      type: 1,
      select: true
    },
    {
      resolution: '1',
      slug: '1m',
      full: '1min',
      res: '1',
      type: 1,
      select: true
    },
    {
      resolution: '3',
      slug: '3m',
      full: '3min',
      res: '3',
      type: 1,
      select: false
    },
    {
      resolution: '5',
      slug: '5m',
      full: '5min',
      res: '5',
      type: 1,
      select: true
    },
    {
      resolution: '15',
      slug: '15m',
      full: '15min',
      res: '15',
      type: 1,
      select: true
    },
    {
      resolution: '30',
      slug: '30m',
      full: '30min',
      res: '30',
      type: 1,
      select: true
    },
    {
      resolution: '60',
      slug: '1H',
      full: '1hour',
      res: '60',
      type: 2,
      select: true
    },
    {
      resolution: '120',
      slug: '2H',
      full: '2hour',
      res: '120',
      type: 2,
      select: false
    },
    {
      resolution: '240',
      slug: '4H',
      full: '4hour',
      res: '240',
      type: 2,
      select: true
    },
    {
      resolution: '360',
      slug: '6H',
      full: '6hour',
      res: '360',
      type: 2,
      select: false
    },
    {
      resolution: '720',
      slug: '12H',
      full: '12hour',
      res: '720',
      type: 2,
      select: false
    },
    {
      slug: '1D',
      resolution: '1440',
      res: '1440',
      full: '1day',
      type: 3,
      select: true
    },
    {
      slug: '1W',
      resolution: '1W',
      res: '1W',
      full: '1week',
      type: 3,
      select: false
    },
    {
      slug: '1M',
      resolution: '1M',
      res: '1M',
      full: '1mon',
      type: 3,
      select: false
    }
  ],
  kline_type: [
    '1',
    '3',
    '5',
    '15',
    '30',
    '60',
    '120',
    '240',
    '360',
    '480',
    '720',
    '1440',
    // '10080',
    'W',
    'M'
    // '44640'
  ],
  REGIST_TYPE: {
    MOBILE: 1,
    EMAIL: 2
  },
  REGISTER_OPTIONS: {
    ALL: 1,
    ONLY_PHONE: 2,
    ONLY_EMAIL: 3,
    EMAIL_AND_CHINA_PHONE: 4
  },
  time_in_force: 'GTC',

  REPAY_WAY: {
    PRINCIPAL: 1, // 还本金
    ALL: 2 // 还币还息
  },
  // 个性化配置默认值
  customConfig: {
    // 闪电平仓
    quickCloseConfirm: true,
    // 默认语言
    lang: isClient ? window.localStorage.lang : '',
    // 默认法币
    unit: isClient ? window.localStorage.unit : '',
    // 行情颜色方案,  0 = 绿涨红跌; 1 = 红涨绿跌
    up_down: 0
  },

  ORDER_TYPE: {
    LIMIT: 'limit',
    MARKET: 'market',
    PLAN: 'plan'
  },

  ENTRUST_TYPE: {
    NORMAL: 'LIMIT,MARKET,LIMIT_MAKER', // 普通委托
    CONDITION: 'CONDITION,CONDITION_LIMIT', // 条件单
    STOP_LOSS: 'CONDITION,CONDITION_LIMIT&' // 止盈止损,接口传参需要把&舍弃
  },

  RECEIVER_TYPE: {
    MOBILE: 1,
    EMAIL: 2
  },

  CONVERT: {
    PRICE_TYPE: {
      STATIC: 1, // 固定价格
      FLOAT: 2 // 浮动价格
    }
  },

  AUTH_TYPE: {
    MOBILE: 1, // 手机
    EMAIL: 2, // 邮箱
    GA: 3 // GA
  },

  // 验证码方式
  CODE_TYPE: {
    LOGIN: 2,
    FIND_PASSWORD: 3,
    UPDATE_PASSWORD: 4,
    BIND_MOBILE: 5,
    BIND_EMAIL: 6,
    BIND_GA: 7,
    CREATE_API_KEY: 11,
    CHANGE_API_KEY: 12,
    DELETE_API_KEY: 13,
    WITHDRAW: 14,
    UNBIND_EMAIL: 17,
    UNBIND_MOBILE: 18,
    UNBIND_GA: 19,
    FISH_CODE: 24,
    CHANGE_BIND_EMAIL: 25,
    CHANGE_BIND_MOBILE: 26,
    CHANGE_BIND_GA: 27,
    UNBIND_THIRD_PARTY: 31,
    BIND_THIRD_PARTY: 32,
    WHITESTATUSUPDATE: 45, // 提币地址白名单开关 发送类型
    WHITELISTUPDATE: 46, // 提币地址白名单更新,新增或删除发送类型
    QUICK_WITHDRAW: 48, // 快捷提币发送类型
    WITHDRAW_LIMIT: 49 // 设置快捷提币额度发送类型
  },

  ACCOUNT_TYPE: {
    COIN: 0,
    MARGIN: 27,
    REWARD: 42 // 活动账户
  },

  TOKEN_TYPE: {
    COIN: 1,
    CONTRACT: 2
  },
  INVITE_TYPE: {
    DIRECT: 1,
    INDIRECT: 2
  },
  ORDER_STATUS: {},
  // 条件单触发类型
  TRIGGER_TYPE: {
    NO_TRIGGER: 0,
    MORE: 1,
    LESS: 2
  },
  // 合约仓位类型
  POSITION_TYPE: {
    ISOLATE: 0,
    MERGE: 1
  },
  // 合约仓位索引
  POSITION_INDEX: {
    LONG: 0,
    SHORT: 1,
    MERGE: 2
  },
  // 合约仓位方向
  POSITION_SIDE: {
    MERGE: 0,
    OPEN: 1,
    CLOSE: 2
  },
  // 合约保证金类型
  MARGIN_TYPE: {
    PART: 0,
    WHOLE: 1
  },
  CONTRACT_TYPE: {
    1: 'linear',
    2: 'swap',
    3: 'contract'
  },
  ACCOUNT_PURPOSE: {
    INVESTMENT: 1,
    TRADING: 2
  },

  KYC_TYPE: {
    UNDEFINED: 0,
    PERSON: 1,
    INSTITUTIONS: 2
  },

  KYC_SYNC_TYPE: {
    GLOBAL: 1,
    SG: 2
  },

  MARGIN_ACTIVITY_ERROR_TYPE: {
    NOT_START: 30050,
    NO_LOAN: 80028,
    NO_ASSETS: 33001,
    NEED_KYC2: 31517,
    EXCEED_LIMIT: 80029
  },

  CAPTCHA_TYPES: {
    GOOGLE: 1,
    SENSE: 2,
    SENSE_PRO: 3
  },
  CAPTCHA_TYPE: 1,
  SITE_KEY: '6Ldk7FUbAAAAAAiLi0buVGyjZ2x_4YhLxcqhjV29', // google_captchaId
  SENSE_ID: '', // 极验的id
  SENSE_PRO_ID: '1b140c59a6da8e906cb4b7ca6687e075', // 深知pro的id
  DEFAULT_NATIONAL_CODE: 65
} as any;
